import React, { useState } from 'react';

export const opties = [
  "4x4 uitvoering",
  "LM-velgen",
  "Sportpakket (exterieur)",
  "Dakrail (zilver)",
  "Dakrail (zwart)",
  "Metallic Lak",
  "Chroom delen exterieur",
  "Bumpers in carrosseriekleur",
  "All season banden",
  "Winterbanden",
  "Dubbel schuif-/kanteldak (elektrisch)",
  "Cabriodak (elektrisch bedienbaar)",
  "Hard top",
  "Panoramadak (el. te openen)",
  "Panoramadak (vast)",
  "Schuif-/kanteldak (elektrisch)",
  "Mistlampen",
  "Xenon koplampen",
  "Xenon koplampen (adaptief)",
  "Bi-xenon koplampen",
  "BI-xenon koplampen (adaptief)",
  "LED achterlichten",
  "LED koplampen",
  "LED koplampen (adaptief)",
  "Laser koplampen",
  "Laser koplampen (adaptief)",
  "Halogeen koplampen",
  "Koplampsproeiers",
  "Bochtverlichting",
  "Bochtverlichting (adaptief)",
  "Dagrijverlichting",
  "Ambiente verlichting",
  "Grootlichtassistent",
  "Buitenspiegels in carrosseriekleur",
  "Buitenspiegels met instapverlichting",
  "El. inklapbare buitenspiegels",
  "El. verstelbare buitenspiegels",
  "Binnen/buitensp. aut. dimmend",
  "Binnenspiegel automatisch dimmend",
  "Buitenspiegel(s) automatisch dimmend",
  "Buitensp elektrisch verwarmbaar",
  "Lichtsensor",
  "Privacy glass",
  "Regensensor",
  "Uitstelbare zijruiten achter",
  "El. bedienbare ramen achter",
  "El. bedienbare ramen voor",
  "El. verwarmbare voorruit",
  "Ruitensproeiers verwarmbaar",
  "360 camerasysteem",
  "Achteruitrijcamera",
  "Automatisch inparkeer systeem",
  "Parkeersensoren achter",
  "Parkeersensoren voor",
  "Parkeerassistent",
  "Trekhaak met afneembare kogel",
  "Trekhaak met vaste kogel",
  "Trekhaak met wegklapbare kogel",
  "Trekhaak el. wegklapbaar",
  "Aansluiting Aux",
  "Aansluiting USB",
  "Bluetooth",
  "DAB+",
  "Radio/CD speler",
  "Handsfree bluetooth",
  "Radio",
  "WiFi",
  "Telefoon draadloos oplaadbaar",
  "Spraakbediening",
  "Touchscreen",
  "Luchtvering",
  "Cruise control",
  "Cruise control (adaptief)",
  "Head-up Display",
  "Digitaal dashboard",
  "Snelheidsbegrenzer",
  "Sportonderstel",
  "Winterpakket",
  "Start/stop systeem",
  "Telefoonkoppeling via app",
  "Sportpakket (interieur)",
  "Zwarte hemelbekleding",
  "Airconditioning",
  "Airconditioning achterin",
  "Climate control",
  "Climate control (L/R gescheiden)",
  "Standkachel",
  "Navigatie groot beeldscherm",
  "Navigatie klein beeldscherm",
  "Navigatie voorbereiding",
  "Navigatie via telefoonkoppeling app",
  "Afstandsbediening Centrale Deurvergrendeling",
  "Keyless entry",
  "Keyless entry/start/stop",
  "Keyless start/stop",
  "Alarmsysteem",
  "El. verstelbare bestuurdersstoel",
  "El. verstelb. best. stoel (geheugen)",
  "El. verstelbare passagiersstoel",
  "El. verstelb. pass. stoel (geheugen)",
  "El. verwarmbare bestuurdersstoel",
  "El. verwarmbare passagiersstoel",
  "Massagefunctie bestuurdersstoel",
  "Massagefunctie passagiersstoel",
  "Middenarmsteun voor",
  "Sportstoelen",
  "Ventilatie bestuurdersstoel",
  "Ventilatie passagiersstoel",
  "Verlengbare zitting bestuurdersstoel",
  "Verlengbare zitting passagiersstoel",
  "Verstelbare lendesteun bestuurdersstoel",
  "Verstelbare lendesteun passagiersstoel",
  "Armsteun achter",
  "Achterbank neerklapbaar (gelijke delen)",
  "Achterbank neerklapbaar (ongelijke delen)",
  "Bestuurdersstoel in hoogte verstelbaar",
  "Voorstoelen in hoogte verstelbaar",
  "Comfort stoelen",
  "Verwarmbare achterstoelen",
  "Audiobediening op het stuurwiel",
  "El. verstelbaar stuurwiel",
  "Lederen sportstuurwiel",
  "Lederen stuurwiel",
  "Lederen versnellingspook",
  "Schakelflippers",
  "Verwarmbaar stuurwiel",
  "Multifunctioneel stuur",
  "Stuurkolom in hoogte en diepte verstelbaar",
  "Stuurkolom in hoogte verstelbaar",
  "Rijbaanassistentie",
  "Voetgangersveiligheidssysteem",
  "Dode hoek assistentie",
  "Bots herkenning systeem",
  "Bots waarschuwing systeem",
  "Hill hold",
  "Nachtzichtassistent",
  "Verkeersbordherkenning",
  "Vermoeidheids herkenning",
  "Airbag(s) voor",
  "Airbag(s) voor + zij",
  "Airbag(s) voor + zij + overige",
  "2-zits bijrijdersbank",
  "Achterdeuren",
  "Achterklep",
  "Dag-Nacht koeling",
  "Bijrijdersbank",
  "Deeltjes filter",
  "Dubbele cabine",
  "Dubbele cabine met gordels",
  "El. te openen schuifdeur links",
  "El. te openen schuifdeur rechts",
  "Imperiaal",
  "Imperial Ladderrol",
  "Koel-/vriesinstallatie",
  "Koelinstallatie",
  "Kraan",
  "Krik",
  "Laadbak",
  "Laadklep",
  "Laadlift",
  "Laadruimte bekleed",
  "Laadruimte met betonplexvloer",
  "Laadruimte met deuren",
  "Laadruimte met deuren en ruit",
  "Laadruimte met klep",
  "Laadruimte met klep met ruit",
  "Laadruimte met rubberenmat",
  "Laadruimte met verlichting",
  "Lat om lat",
  "Parkeersensoren achter in treeplank",
  "Roof rack",
  "Schuifdeur links",
  "Schuifdeur links en rechts",
  "Schuifdeur rechts",
  "Schuifdeur tussen cabine en laadruimte",
  "Sidebars",
  "Tussenschot laag",
  "Tussenschot volledig",
  "Tussenschot volledig met ruit",
  "Verhoogd dak",
  "Verhoogd dak in carrosseriekleur",
  "Ruitenwisser achter",
  "Lichtmetalen velgen"
];

const OptionsModal = ({ isOpen, onClose, onApply, initialOptions }) => {
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedOptions, setSelectedOptions] = useState(initialOptions || []);

  const handleOptionToggle = (option) => {
    setSelectedOptions(prev => {
      if (prev.includes(option)) {
        return prev.filter(item => item !== option);
      } else {
        return [...prev, option];
      }
    });
  };

  const handleApply = () => {
    onApply(selectedOptions);
    onClose();
  };

  if (!isOpen) return null;

  const filteredOptions = opties.filter(option =>
    option.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div className="fixed inset-0 z-50 overflow-y-auto">
      <div className="fixed inset-0 bg-black opacity-50" onClick={onClose}></div>
      <div className="relative min-h-screen flex items-center justify-center p-4">
        <div className="relative bg-white rounded-lg shadow-xl max-w-2xl w-full p-6">
          <div className="flex justify-between items-center mb-4">
            <h3 className="text-xl font-bold">Select Options</h3>
            <button onClick={onClose} className="text-gray-500 hover:text-gray-700">
              <svg className="h-6 w-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>

          <input
            type="text"
            placeholder="Search options..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="w-full p-2 border rounded-lg mb-4"
          />

          <div className="max-h-96 overflow-y-auto border rounded-lg p-2">
            {filteredOptions.map((option, index) => (
              <div
                key={index}
                className="flex items-center p-2 hover:bg-gray-100 rounded"
              >
                <input
                  type="checkbox"
                  id={`option-${index}`}
                  checked={selectedOptions.includes(option)}
                  onChange={() => handleOptionToggle(option)}
                  className="h-4 w-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500"
                />
                <label
                  htmlFor={`option-${index}`}
                  className="ml-2 cursor-pointer flex-grow"
                >
                  {option}
                </label>
              </div>
            ))}
          </div>

          <div className="mt-4 flex justify-between items-center">
            <span className="text-sm text-gray-600">
              Selected: {selectedOptions.length} options
            </span>
            <div className="flex gap-2">
              <button
                onClick={onClose}
                className="px-4 py-2 bg-gray-500 text-white rounded-lg hover:bg-gray-600"
              >
                Cancel
              </button>
              <button
                onClick={handleApply}
                className="px-4 py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600"
              >
                Apply
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OptionsModal;
